<template>
<div>
  <div class="emd-container">
    <div class="emd-container__header eu-py_4_md eu-px_5_md">
      <h2 class="emd-text _size_section _color_default">
        {{ $t('title') }}
      </h2>
    </div>
    <hr class="emd-divider">
    <div class="emd-container__content eu-pa_5_md">
      <emd-alert v-if="tabbarError.status" variant="danger" :title="$t('tabbarError')" @cancel="tabbarError.status = false" autoclose />
      <div class="el-chunk">
        <p class="emd-text">{{ $t('subtitle') }}</p>
      </div>
      <form action="">
        <div class="eu-flex eu-container">
          <div class="_border_base emd-credit-card emd-form-box eu-flex-item eu-basis_12 eu-basis_6_md">
            <div class="eu-flex">
              <div class="eu-flex-item basis_4_sm eu-basis_12">
                <div class="emd-form-group">
                  <label class="emd-label _required" for="holder_name">{{ $t('name') }}</label>
                  <input class="emd-input eu-uppercase" type="text" name="holder_name" id="holder_name" placeholder="MARIA S SILVA" v-model="card.holder_name" @input="validateName" :class="{ '_state_error': $v.card.holder_name.$invalid && showFeedbacks.status }" />
                  <p class="emd-input-feedback _state_error" v-if="$v.card.holder_name.$invalid && showFeedbacks.status">{{ $t('hint.required') }}</p>
                </div>
              </div>
              <div class="eu-flex-item eu-basis_8_sm eu-basis_12">
                <div class="emd-form-group">
                  <label class="emd-label _required" for="card_number">{{ $t('cardNumber') }}</label>
                  <div class="emd-input-group">
                    <the-mask class="emd-input fs-hide" type="text" name="card_number" id="card_number" placeholder="0000 0000 0000 0000" v-model="card.number" :mask="['#### #### #### #### ###']"
                    :class="{
                      '_state_error': $v.card.number.$invalid && showFeedbacks.status
                    }" />
                    <i class="uil uil-credit-card"></i>
                  </div>
                  <p class="emd-input-feedback _state_error" v-if="$v.card.number.$invalid && showFeedbacks.status && !card.number.length">{{ $t('hint.required') }}</p>
                  <p class="emd-input-feedback _state_error" v-if="$v.card.number.$invalid && showFeedbacks.status && card.number.length">{{ $t('hint.number') }}</p>
                </div>
              </div>
              <div class="eu-flex-item eu-basis_4_sm eu-basis_12">
                <div class="emd-form-group" :class="{ '_state_warning': selectedManually }">
                  <label class="emd-label _required" for="brand">{{ $t('brand') }}</label>
                  <div class="emd-select" :class="{ '_state_error': $v.card.label.$invalid && showFeedbacks.status }">
                    <select id="brand" name="brand" v-model="card.label" :disabled="loadBrand" @change="reloadBrand" >
                      <option value="">{{ $t('defaultSelect') }}</option>
                      <option v-for="(brand, index) in brands" :key="index" :value="brand">{{ brand }}</option>
                    </select>
                    <div class="emd-select__arrow"></div>
                  </div>
                  <p class="emd-input-feedback _state_error" v-if="$v.card.label.$invalid && showFeedbacks.status">{{ $t('hint.select') }}</p>
                </div>
              </div>
              <div class="eu-flex-item eu-basis_4_sm eu-basis_6">
                <div class="emd-form-group">
                  <label class="emd-label _required" for="expiration">{{ $t('expiration') }}</label>
                  <input class="emd-input fs-hide" type="text" name="expiration" id="expiration" placeholder="00/00" v-mask="'##/##'" v-model="exp_date" @input="setExpMonthYear" :class="{ '_state_error': $v.exp_date.$invalid && showFeedbacks.status }" />
                  <p class="emd-input-feedback _state_error" v-if="$v.exp_date.$invalid && showFeedbacks.status && !exp_date.length">{{ $t('hint.required') }}</p>
                  <p class="emd-input-feedback _state_error" v-if="$v.exp_date.$invalid && showFeedbacks.status && exp_date.length">{{ $t('hint.exp_date') }}</p>
                </div>
              </div>
              <div class="eu-flex-item eu-basis_4_sm eu-basis_6">
                <div class="emd-form-group">
                  <label class="emd-label _required" for="cvv">{{ $t('cvv') }}</label>
                  <the-mask ref="apps" v-click-outside="clickedOutside" class="emd-input fs-hide" type="text" name="cvv" id="cvv" placeholder="000" v-model="card.cvv" :mask="['###', '####']" @input="validateCvv" :class="{ '_state_error': $v.card.cvv.$invalid && showFeedbacks.status }" />
                  <p class="emd-input-feedback _state_error" v-if="$v.card.cvv.$invalid && showFeedbacks.status && !card.cvv.length">{{ $t('hint.required') }}</p>
                  <p class="emd-input-feedback _state_error" v-if="$v.card.cvv.$invalid && showFeedbacks.status && card.cvv.length">{{ $t('hint.cvv', { digits: cvvDigits }) }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="eu-flex-item eu-basis_12 eu-basis_6_md">
            <credit-card :card="card" :flipped="flipped"/>
          </div>
        </div>
        <div class='eu-mt_4'>
          <statement-descriptor
            :creditCard='credit_card'
            :statementDescriptorFeedbackError=statementDescriptorFeedbackError
            @setStatementDescriptorFeedbackError=setStatementDescriptorFeedbackError
          />
        </div>
        <div class="el-chunk eu-mt_4">
          <label v-if="isPSP" class="emd-label _required">{{ $t('address.title') }}</label>
          <label v-else class="emd-label">{{ $t('address.title') }}</label>
        </div>
        <div class="el-chunk" v-if="!isPSP">
          <div class="emd-form-box__header">
            <label class="emd-checkbox" for="showaddress">
              <input class="emd-checkbox__input" name="showaddress" type="checkbox" id="showaddress" v-model="billingAddress.show_address" />
              <div class="emd-checkbox__area"></div>
              <span class="eu-ml_2">{{ $t('address.toggle_checkbox') }}</span>
            </label>
          </div>
        </div>
        <div class="emd-form-box  eu-basis_12_md" :class="{ '_active': shouldBeOpenAddressBox, '_border_base': shouldBeOpenAddressBox  }">
          <div class="emd-form-box__content" :class="{ '_active': billingAddress.use_client_address }" v-if="shouldShowUseClientAddressCheckBox">
            <label class="emd-checkbox" for="useclientaddress">
              <input class="emd-checkbox__input" name="useclientaddress" type="checkbox" id="useclientaddress" v-model="billingAddress.use_client_address" />
              <div class="emd-checkbox__area"></div>
              <span class="eu-ml_2">{{ $t('address.use_client_address_checkbox') }}</span>
            </label>
          </div>
          <div class="emd-form-box__content">
              <address-card v-if="shouldBeOpenAddressCard"/>
              <address-form v-else :address="billingAddress" :required="isPSP" @toggle="toggleAddressFormState"/>
          </div>
        </div>
        <div class="el-chunk eu-mt_4" v-if="enabledInstallments">
          <div class="el-chunk">
            <p class="emd-text">{{ $t('installment.title') }}</p>
          </div>
          <div class="eu-basis_7_md eu-flex">
            <div class="emd-form-group eu-flex-item eu-basis_12 eu-basis_6_md eu-basis_12_sm">
              <label class="emd-label _required">{{ $t('installment.label') }}</label>
              <div class="emd-select" :class="{ '_state_error': $v.credit_card.installments.$invalid && showFeedbacks.status }">
                <select id="installments" name="installments" v-model="credit_card.installments">
                  <option v-for="index in 12" :key="index" :value="index">{{`${index}x ${$t('of')} ${setInstallment(index)} `}}</option>
                </select>
                <div class="emd-select__arrow"></div>
              </div>
              <p class="emd-input-feedback _state_error" v-if="$v.credit_card.installments.$invalid && showFeedbacks.status">{{ $t('hint.select') }}</p>
            </div>
            <div class="emd-form-group eu-flex-item eu-basis_12 eu-basis_6_md eu-basis_12_sm">
              <label class="emd-label _required" style="display: initial">{{ $t('operation.label') }}</label>
              <emd-tippy data-template="info" id="info" class="eu-ml_1" :type="'html'" position="bottom">
                <i class="uil uil-info-circle emd-text _color_subtle" />
                <emd-tippy-template-HTML id="info">
                  <div style="text-transform: initial; letter-spacing: 0;">
                    <p>
                      {{ $t('operation.info.label') }}
                      <a class="emd-link" :href="urlAuthOnly" target="_blank" rel="noopener noreferrer">{{ $t('operation.info.link') }}</a>
                    </p>
                  </div>
                </emd-tippy-template-HTML>
              </emd-tippy>
              <label class="emd-radio-button eu-flex eu-px_3 eu-py_2">
                <input class="emd-radio-button__input" type="radio" name="operation_radio" value="auth_and_capture" v-model="card.operation"/>
                <div class="emd-radio-button__area"></div>
                <span class="emd-radio-button__text">{{ $t('operation.radio.authorize_capture') }}</span>
              </label>
              <label class="emd-radio-button eu-flex eu-px_3 eu-py_2">
                <input class="emd-radio-button__input" type="radio" name="operation_radio" value="auth_only" v-model="card.operation"/>
                <div class="emd-radio-button__area"></div>
                <span class="emd-radio-button__text">{{ $t('operation.radio.authorize_only') }}</span>
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="el-section">
    <div class="eu-display_flex eu-justify_space-between eu-wrap_reverse">
      <button class="emd-btn _color_secondary _type_text _block_mobile" @click="reverseRoute" :disabled="loadBrand">
         <i class="uil uil-angle-left"></i>
        {{ $t('customer') }}
      </button>
      <button class="emd-btn _color_secondary _block_mobile eu-mb_5 eu-no-margin_sm" @click="nextRoute" :disabled="loadBrand">
        {{ $t('review') }}
         <i class="uil uil-angle-right"></i>
      </button>
    </div>
  </div>
</div>
</template>

<script>
import EmdAlert from '@/components/emerald/molecules/EmdAlert'
import CreditCard from '@/components/project/CreditCard'
import EmdTippy from '@/components/emerald/atoms/EmdTippy'
import EmdTippyTemplateHTML from '@/components/emerald/atoms/EmdTippyTemplateHTML'
import AddressForm from '@/components/project/AddressForm'
import AddressCard from '@/components/project/AddressCard'
import { required } from 'vuelidate/lib/validators'
import { isValidCard, isValidExpDate, formatCurrency, formatToInt } from '@/utils/validations'
import StatementDescriptor from '@/components/project/StatementDescriptor.vue'

export default {
  name: 'PaymentCreditCard',
  components: {
    EmdAlert,
    CreditCard,
    EmdTippy,
    EmdTippyTemplateHTML,
    AddressForm,
    AddressCard,
    StatementDescriptor
  },
  data () {
    return {
      exp_date: '',
      loadBrand: false,
      brandNotFound: false,
      currentCard: null,
      cardNumberFirstDigits: '',
      flipped: false,
      addressFormIsInvalid: true,
      statementDescriptorFeedbackError: false
    }
  },
  computed: {
    enabledInstallments () {
      return ['items', 'typed-sale'].includes(this.selectedPaymentType)
    },
    customerAddress () {
      return this.$store.getters.address
    },
    billingAddress () {
      return this.$store.getters.billing_address
    },
    card () {
      return this.$store.getters.card
    },
    cardNumber () {
      return this.card.number
    },
    credit_card () {
      return this.$store.getters.credit_card
    },
    brands () {
      return this.$store.getters.brands
    },
    selectedManually () {
      return this.creditCardBrand.label ? this.card.label !== this.creditCardBrand.label : false
    },
    formIsInvalid () {
      if (this.billingAddress.show_address) return this.$v.$invalid || (this.addressFormIsInvalid && !this.useClientAddress)
      else return this.$v.$invalid
    },
    totalAmount () {
      return this.$store.getters.total.amount
    },
    tabbarError () {
      return this.$store.getters.tabbarError
    },
    showFeedbacks () {
      return this.$store.getters.showFeedbacks
    },
    creditCardBrand () {
      return this.$store.getters.creditCardBrand
    },
    selectedPaymentType () {
      return this.$store.getters.selectedPaymentType
    },
    cvvDigits () {
      if (this.creditCardBrand.cvv && !this.selectedManually) return this.creditCardBrand.cvv
      else return this.card.label === 'Amex' ? 4 : 3
    },
    urlAuthOnly () {
      return `${process.env.VUE_APP_URL_AUTH_ONLY}`
    },
    useClientAddress () {
      if (this.customerAddress.show_address) return this.billingAddress.use_client_address
      else return false
    },
    shouldShowUseClientAddressCheckBox () {
      return this.isPSP && this.customerAddress.show_address
    },
    shouldBeOpenAddressCard () {
      return this.billingAddress.use_client_address && this.customerAddress.show_address
    },
    getBusinessModel () {
      return this.$store.getters.business_model
    },
    isPSP () {
      return this.getBusinessModel === 'p_s_p'
    },
    showAddress () {
      return this.billingAddress.show_address
    },
    shouldBeOpenAddressBox () {
      return this.isPSP || this.billingAddress.show_address
    }
  },
  validations: {
    card: {
      number: {
        required,
        isValidCard
      },
      holder_name: {
        required
      },
      cvv: {
        required,
        maxLength: function () { return this.validateCreditCardBrandCvv() }
      },
      label: { required }
    },
    options: {
      verify_card: true
    },
    credit_card: {
      installments: {
        required
      }
    },
    exp_date: {
      required,
      isValidExpDate
    }
  },
  methods: {
    setStatementDescriptorFeedbackError (statementFeedbackErrorEvent) {
      this.statementDescriptorFeedbackError = statementFeedbackErrorEvent
    },
    getBrandByBin () {
      if (!this.loadBrand) {
        this.loadBrand = true
        this.$store.dispatch('GET_BRAND', this.card.number.substring(0, 6))
          .then((res) => {
            if (res === undefined) {
              this.brandNotFound = true
              this.card.label = ''
              this.creditCardBrand = {}
            } else {
              this.brandNotFound = false
              this.card.label = res.name
              this.creditCardBrand.label = res.name
              this.creditCardBrand.cvv = res.cvv
              this.creditCardBrand.lenghts = res.bins
            }
            this.loadBrand = false
          })
      } else this.creditCardBrand = {}
    },
    validateCreditCardBrandCvv () {
      return this.card.cvv.length === this.cvvDigits
    },
    setExpMonthYear () {
      this.card.exp_month = parseInt(this.exp_date.split('/')[0])
      this.card.exp_year = parseInt(this.exp_date.split('/')[1])
    },
    setInstallment (value) {
      return formatCurrency((formatToInt(this.totalAmount) / value) / 100)
    },
    validateInstallments () {
      this.credit_card.installments = this.credit_card.installments.slice(0, 2)
    },
    validateCvv () {
      this.flipped = true
      this.card.cvv = this.card.cvv.replace(/[^\d]+/g, '')
    },
    validateName () {
      this.card.holder_name = this.card.holder_name.replace(/\d+|^\s+$/g, '')
    },
    reloadBrand () {
      delete this.creditCardBrand.cvv
      this.validateCvv()
    },
    nextRoute () {
      if (this.statementDescriptorFeedbackError) return false
      if (this.formIsInvalid) {
        this.showFeedbacks.status = true
        if (this.billingAddress.show_address) this.showFeedbacks.address = true
      } else {
        this.addressFormIsInvalid = false
        this.$router.push({ name: 'ReviewOrder' })
      }
    },
    reverseRoute () {
      this.$router.push({ name: 'Customer' })
    },
    clickedOutside () {
      this.flipped = false
    },
    toggleAddressFormState (state) {
      this.addressFormIsInvalid = state
    }
  },
  beforeMount () {
    if (parseInt(this.card.exp_month) < 10) this.exp_date = `0${this.card.exp_month}/${this.card.exp_year}`
    else this.exp_date = `${this.card.exp_month}/${this.card.exp_year}`

    if (!this.isPSP) this.billingAddress.show_address = false
    else this.billingAddress.show_address = true
  },
  watch: {
    formIsInvalid: {
      handler: function () {
        this.$store.dispatch('SET_PERMISSION', {
          status: this.formIsInvalid,
          component: this.$route.name,
          paymentType: this.selectedPaymentType
        })
        this.tabbarError.status = false
        this.showFeedbacks.status = false
      }
    },
    cardNumber: {
      handler: function () {
        if (this.cardNumberFirstDigits !== this.card.number.substring(0, 6) && this.card.number.length > 12) {
          this.cardNumberFirstDigits = this.card.number.substring(0, 6)
          this.getBrandByBin()
        }
      }
    },
    showAddress: {
      handler: function () {
        this.showFeedbacks.address = false
      }
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Informe os dados pagamento",
      "subtitle": "Quais os dados do cartão do comprador?",
      "cardNumber": "Número do cartão",
      "brand": "Bandeira",
      "name": "Nome como está no cartão",
      "expiration": "Validade",
      "cvv": "CVV",
      "installment": {
        "title": "Como a cobrança do valor deve ser feita?",
        "label": "Parcelamento"
      },
      "operation": {
        "label": "Operação",
        "radio": {
          "authorize_capture": "Autorizar e capturar",
          "authorize_only": "Autorizar somente"
        },
        "info": {
          "label": "Para saber mais sobre tipos de operações acesse nosso artigo na",
          "link": "Central de Ajuda"
        }
      },
      "defaultSelect": "Selecione",
      "review": "Resumo",
      "customer": "Dados do Cliente",
      "leadTitle": "Como a cobrança do valor deve ser feita?",
      "hint": {
        "required": "Este campo é obrigatório",
        "select": "É necessário selecionar uma opção",
        "number": "Número inválido",
        "exp_date": "A data deve ser válida",
        "cvv": "O CVV deve ter {digits} dígitos",
        "statementDescriptor": "Até 13 caracteres"
      },
      "address": {
        "title": "Endereço de cobrança",
        "use_client_address_checkbox": "Utilizar endereço do cliente",
        "toggle_checkbox": "Adicionar Endereço",
        "zipcode": {
          "label": "CEP",
          "hint": "CEP não encontrado.",
          "link": "Não sei meu CEP"
        },
        "street": {
          "label": "Logradouro",
          "hint": "Digite a rua, avenida ou similar"
        },
        "number": {
          "label": "Número",
          "hint": "Digite somente números."
        },
        "complement": {
          "label": "Complemento",
          "hint": "Digite somente números e/ou letras."
        },
        "neighborhood": "Bairro",
        "city": "Cidade",
        "state": "Estado",
        "country": "País"
      },
      "tabbarError": "Alguns campos não foram preenchidos corretamente, por favor verifique.",
      "of": "de"
    },
    "en-US": {
      "title": "Payment information",
      "subtitle": "Buyer`s card info",
      "cardNumber": "Card number",
      "brand": "Brand",
      "name": "Name as is at the card",
      "expiration": "Expiration",
      "cvv": "CVV",
      "installment": {
        "title": "How should the charge be made?",
        "label": "Installment"
      },
      "operation": {
        "label": "Operação",
        "radio": {
          "authorize_capture": "Authorize and capture",
          "authorize_only": "Authorize only"
        },
        "info": {
          "label": "To learn more about types of operations,",
          "link": "visit our article at"
        }
      },
      "address": {
        "title": "Billing address",
        "use_client_address_checkbox": "Use client address",
        "toggle_checkbox": "Add Address",
        "zipcode": {
          "label": "Zip code",
          "hint": "CEP not found.",
          "link": "I do not know my zipcode"
        },
        "street": {
          "label": "Line 1",
          "hint": "Insert a street, avenue or similar"
        },
        "number": {
          "label": "Number",
          "hint": "Insert numbers only."
        },
        "complement": {
          "label": "Line 2",
          "hint": "Insert numbers and/or letters only."
        },
        "neighborhood": "neighborhood",
        "city": "City",
        "state": "State",
        "country": "Country"
      },
      "defaultSelect": "Select",
      "review": "Review",
      "customer": "Customer",
      "leadTitle": "How the charge must be applied?",
      "hint": {
        "required": "This field is required",
        "select": "An option must be selected",
        "number": "Invalid number",
        "exp_date": "Date must be valid",
        "cvv": "The CVV must be a 3 or 4-digit number"
      },
      "tabbarError": "Some fields were filled incorrectly, please verify.",
      "of": "of"
    }
  }
</i18n>

<style scoped>
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>
